import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useDispatch, useSelector } from 'react-redux'
import { Tabs, Button } from '../root/components/common'
import ChooseLocations from './choose-locations'
import ChooseDevices from './choose-devices'
import ChooseReports from './choose-reports'
import { SYSTEM_COMPONENTS_IDS } from '../root/constants'
import * as actions from './actions'

const useStyles = makeStyles(theme => ({
    wrapper: {
        height: '100%',
        display: 'flex'
    },
    confirmInfoSection: {
        flex: 1
    },
    confirmInfoTitle: {
        fontSize: 20,
        marginBottom: 12
    },
    confirmButtonWrapper: {
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
}))

export default function ConfirmShare(props){
    const classes = useStyles()
    const dispatch = useDispatch()

    const { isLoading, p, user, locale } = useSelector(state => state.main)
    const {
        selectedSharedUsers,
        selectedLocations,
        selectedDevices,
        selectedReports,
        isSharingSuccess
    } = useSelector(state => state.sharing)
    const { setActiveStep } = props

    const onConfirm = () => {
        const dataToShare = selectedSharedUsers.reduce((acc, user) => {
            const locations = selectedLocations.map(l => ({
                entity_id: l.id,
                user_id: user.id,
                component_name: SYSTEM_COMPONENTS_IDS.locations
            }))
            acc.locations = [...acc.locations, ...locations]
            const devices = selectedDevices.map(d => ({
                entity_id: d.id,
                user_id: user.id,
                component_name: SYSTEM_COMPONENTS_IDS.devices
            }))
            acc.devices = [...acc.devices, ...devices]
            const reports = selectedReports.map(r => ({
                entity_id: r.id,
                user_id: user.id,
                component_name: SYSTEM_COMPONENTS_IDS.reports
            }))
            acc.reports= [...acc.reports, ...reports]
            return acc
        }, {
            locations: [],
            devices: [],
            reports: []
        })
        dispatch(actions.shareRequest(
            dataToShare.locations,
            dataToShare.devices,
            dataToShare.reports
        ))
    }

    useEffect(() => {
        if (isSharingSuccess === true) {
            setActiveStep(3)
        }
    }, [isSharingSuccess])

    return (
        <div className={classes.wrapper}>
            <div className={classes.confirmInfoSection}>
            {selectedLocations.length > 0 &&
                    <React.Fragment>
                        <div className={classes.confirmInfoTitle}>
                            {locale.sharing.locations}
                        </div>
                        {selectedLocations.map((l, idx) => {
                            return (
                                <div
                                    key={l.id}
                                >
                                    {`${idx + 1}. ${l.name}`}
                                </div>
                            )
                        })}
                    </React.Fragment>
                }
            </div>
            <div className={classes.confirmInfoSection}>
                {selectedDevices.length > 0 &&
                    <React.Fragment>
                        <div className={classes.confirmInfoTitle}>
                            {locale.sharing.devices}
                        </div>
                        {selectedDevices.map((d, idx) => {
                            return (
                                <div
                                    key={d.id}
                                >
                                    {`${idx + 1}. ${d.name} - ${d.serial_number}`}
                                </div>
                            )
                        })}
                    </React.Fragment>
                }
            </div>
            <div className={classes.confirmInfoSection}>
                {selectedReports.length > 0 &&
                    <React.Fragment>
                        <div className={classes.confirmInfoTitle}>
                            {locale.sharing.reports}
                        </div>
                        {selectedReports.map((r, idx) => {
                            return (
                                <div
                                    key={r.id}
                                >
                                    {`${idx + 1}. ${r.name} - ${r.created_at}`}
                                </div>
                            )
                        })}
                    </React.Fragment>
                }
            </div>
            <div className={classes.confirmInfoSection}>
                <React.Fragment>
                    <div className={classes.confirmInfoTitle}>
                        {locale.sharing.willBeSharedWith}
                    </div>
                    {selectedSharedUsers.map((u, idx) => {
                        return (
                            <div
                                key={u.id}
                            >
                                {`${u.name}`}
                            </div>
                        )
                    })}
                </React.Fragment>
            </div>
            <div className={classes.confirmInfoSection}>
                <div className={classes.confirmButtonWrapper}>
                    <Button
                        onClick={onConfirm}
                    >
                        {locale.sharing.confirmAndShare}
                    </Button>
                </div>
            </div>
        </div>
    )
}
